import axios from "../axios";
import { Cookies } from "react-cookie";
const endPoint = `/crm/projects/`;

const cookie = new Cookies();

export const createProject = async ({ name, region }) => {
  const token = cookie.get("crm");
  const res = await axios.post(
    `${endPoint}create`,
    { name, region },
    { headers: { Authorization: token } },
  );
  return res;
};

export const getProjects = async (page) => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}all?page=${page}`, {
    headers: { Authorization: token },
  });
  return res;
};

export const getRegions = async () => {
  const token = cookie.get("crm");
  const res = await axios.get(`/crm/location`, {
    headers: { Authorization: token },
  });
  return res;
};

export const deleteProjects = async ({ projects }) => {
  const token = cookie.get("crm");
  const res = await axios.put(
    `${endPoint}delete`,
    { projects },
    {
      headers: { Authorization: token },
    },
  );
  return res;
};
